import { render } from "./404.vue?vue&type=template&id=3f34fbc6&scoped=true&ts=true"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"

import "./404.vue?vue&type=style&index=0&id=3f34fbc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f34fbc6"]])

export default __exports__